export default "__VITE_ASSET__DN$Jq0pi__"